{
    "NAME": "Langage de gestion des licences",
    "LicenseManagement_Action_Refresh": "Actualiser l'état de la licence",
    "LicenseManagement_Action_Reload": "Recharger les licences",
    "LicenseManagement_Reload_Confirm": "Recharger les données de licence ?",
    "LicenseManagement_Reload_Success": "Données de licence rechargées.",
    "LicenseManagement_Status_Title": "État actuel de la licence",
    "LicenseManagement_Status_Empty": "Aucun statut de licence n'est disponible.",
    "LicenseManagement_Status_LimitedAccess": "Seul le statut global de la licence est disponible pour le périmètre actuel.",
    "LicenseManagement_Status_Entry": "Entrée",
    "LicenseManagement_Status_Value": "Valeur",
    "LicenseManagement_Status_Usage": "Usage",
    "LicenseManagement_Status_Status": "Statut",
    "LicenseManagement_Profiles_Title": "Profils du serveur de téléphonie",
    "LicenseManagement_Profiles_Empty": "Aucun profil de serveur de téléphonie n'est disponible.",
    "LicenseManagement_Billing_Title": "Rapports de facturation",
    "LicenseManagement_Billing_Filters": "Filtres",
    "LicenseManagement_Billing_Advanced": "Options avancées",
    "LicenseManagement_Billing_Actions": "Actes",
    "LicenseManagement_Billing_OnlyBillable": "Configuration facturable uniquement",
    "LicenseManagement_Billing_SystemWideUsers": "Inclure les utilisateurs à l'échelle du système",
    "LicenseManagement_Billing_BillingExcluded": "Inclure les configurations exclues de la facturation",
    "LicenseManagement_Billing_Simulation": "Inclure des systèmes téléphoniques de simulation",
    "LicenseManagement_Billing_Summary": "Résumé de facturation",
    "LicenseManagement_Billing_Cdr": "Facturation des CDR",
    "LicenseManagement_Billing_SummaryConfirm": "Générer le rapport de synthèse de facturation ?",
    "LicenseManagement_Billing_CdrConfirm": "Générer le rapport CDR de facturation ?",
    "LicenseManagement_Diagnostic": "Rapport de diagnostic",
    "LicenseManagement_Diagnostic_Confirm": "Générer le rapport de licence de diagnostic ?",
    "LicenseManagement_Filter_Cme": "Formation médicale continue",
    "LicenseManagement_Filter_TelSys": "Serveur de téléphonie",
    "LicenseManagement_Filter_Partition": "Partition"
}